import type { RxDocument } from 'rxdb';

import { capture } from '@/analytics';

type DocumentLifecycleEvent = 'document_created' | 'document_deleted';

const analyticsDocumentCollections = new Set(['blocks', 'notes', 'userSources']);

export const captureDocumentLifecycleEvent = (
  event: DocumentLifecycleEvent,
  collectionName: string,
  docs: Array<RxDocument<any>>
) => {
  if (!analyticsDocumentCollections.has(collectionName)) {
    return;
  }

  const documentTypeCounts = getDocumentTypeCounts(collectionName, docs);

  if (event === 'document_created') {
    for (const documentType of Object.keys(documentTypeCounts)) {
      capture('document_created', { document_type: documentType });
    }
    return;
  }

  for (const [documentType, count] of Object.entries(documentTypeCounts)) {
    capture('document_deleted', { document_type: documentType, count });
  }
};

const getDocumentTypeCounts = (collectionName: string, docs: Array<RxDocument<any>>) => {
  return docs.reduce<Record<string, number>>((counts, doc) => {
    const documentType = getAnalyticsDocumentType(collectionName, doc.toJSON?.() ?? doc);
    counts[documentType] = (counts[documentType] ?? 0) + 1;
    return counts;
  }, {});
};

const getAnalyticsDocumentType = (collectionName: string, doc: { variant?: string }) => {
  if (collectionName === 'notes') {
    return doc.variant ?? 'notes';
  }

  return collectionName;
};
